import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    release: __APP_VERSION__,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled: true,
    denyUrls: [/localhost/i, /127\.0\.0\.1/i],
  });
}

export function setPulseUserContext(user: {
  id: string;
  email?: string | null;
} | null) {
  if (user) {
    Sentry.setUser({
      id: user.id,
      ...(user.email ? { email: user.email } : {}),
    });
  } else {
    Sentry.setUser(null);
  }
}

export function setPulseAccessContext(accessState: string) {
  Sentry.setTag("pulse_access_state", accessState);
  Sentry.setTag("app_release", __APP_VERSION__);
}
